import { StFeatureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import Service from '@/services/Service';
import { error401Handler } from '@/utils/error';

const urlConfig = {
  production: {
    version: StFeatureFlagFlags.UserLegacyServiceVersionProd.getValue(),
    gateway: StFeatureFlagFlags.gatewayProd.getValue(),
  },
  staging: {
    version: StFeatureFlagFlags.UserLegacyServiceVersionStaging.getValue(),
    gateway: StFeatureFlagFlags.gatewayStaging.getValue(),
  },
};

const afterParser = response => response.data;

export default class ExternalRoleService extends Service {
  constructor(isStaging) {
    const { version, gateway } = isStaging ? urlConfig.staging : urlConfig.production;

    const api = createApi(`upms-legacy/${version}/user-roles/`, gateway, { error401Handler });
    super(api, { afterParser });
  }

  isAdmin(accountId) {
    return this.find({ url: `is-admin?accountId=${accountId}` });
  }
}
